<template>
<div class="chapter">
<div class="inner_page">
<p class="P_x-0-Basic-paragraph-NO-INDENT_para-style-override-11">Copyright © 2014</p>
<p class="P_x-0-Basic-paragraph-NO-INDENT_para-style-override-11">By Barbara Sillery</p>
<p class="P_x-0-Basic-paragraph-NO-INDENT_para-style-override-11">All rights reserved</p>
<p class="P_x-0-Basic-paragraph-NO-INDENT_para-style-override-7">The word “Pelican” and the depiction of a pelican are</p>
<p class="P_x-0-Basic-paragraph-NO-INDENT_para-style-override-7">trademarks of Pelican Publishing Company, Inc., and are</p>
<p class="P_x-0-Basic-paragraph-NO-INDENT_para-style-override-7">registered in the U.S. Patent and Trademark Office.</p>
<p class="P_x-0-Basic-paragraph-NO-INDENT_para-style-override-12">Library of Congress Cataloging-in-Publication Data</p>
<p class="P_x-0-Basic-paragraph-NO-INDENT_para-style-override-13">Sillery, Barbara.</p>
<p class="P_x-0-Basic-paragraph-NO-INDENT_para-style-override-13">The haunting of Cape Cod and the Islands / by Barbara Sillery.</p>
<p class="P_x-0-Basic-paragraph-NO-INDENT_para-style-override-13">pages cm</p>
<p class="P_x-0-Basic-paragraph-NO-INDENT_para-style-override-13">ISBN 978-1-4556-1993-1 (pbk. : alk. paper) — ISBN 978-1-4556-1994-8 (e-book) 1. Ghosts—Massachusetts—Cape Cod. 2. Haunted places—Massachusetts—Cape Cod. I. Title.</p>
<p class="P_x-0-Basic-paragraph-NO-INDENT_para-style-override-13">BF1472.U6S5345 2014</p>
<p class="P_x-0-Basic-paragraph-NO-INDENT_para-style-override-13">133.109744’9—dc23</p>
<p class="P_x-0-Basic-paragraph-NO-INDENT_para-style-override-13">2014025692</p>
<p class="P_x-0-Basic-paragraph-NO-INDENT">Photographs by Barbara Sillery unless otherwise indicated</p>
<p class="P_x-0-Basic-paragraph-NO-INDENT_para-style-override-11"><img alt="" src="image1.jpg" style=" max-width: 100%; max-height: 100%;"/></p>
<p class="P_x-0-Basic-paragraph-NO-INDENT_para-style-override-14">Printed in the United States of America</p>
<p class="P_x-0-Basic-paragraph-NO-INDENT_para-style-override-11">Published by Pelican Publishing Company, Inc.</p>
<p class="P_x-0-Basic-paragraph-NO-INDENT_para-style-override-15"><span style=" font-size: 0.92em;">1000 Burmaster Street, Gretna, Louisiana 70053</span></p>
<p class="P_x-0-Basic-paragraph-NO-INDENT_para-style-override-7">To Glinda Schafer, an ext<a id="Anchor"></a>raordinary artist and an extraordinary friend. Thank you for all the years of being there for me.</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// section0003.vue?312dc79e